import { render, staticRenderFns } from "./PrivateKeysPage.vue?vue&type=template&id=6740d54a&"
import script from "./PrivateKeysPage.vue?vue&type=script&lang=js&"
export * from "./PrivateKeysPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6740d54a')) {
      api.createRecord('6740d54a', component.options)
    } else {
      api.reload('6740d54a', component.options)
    }
    module.hot.accept("./PrivateKeysPage.vue?vue&type=template&id=6740d54a&", function () {
      api.rerender('6740d54a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/security/PrivateKeysPage.vue"
export default component.exports